<template>
  <main>
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <h3>新闻详情</h3>
              </div>
              <ul class="breadcrumb-bg">
                <router-link to="Blog">
                  <li class="back">< 返回</li></router-link
                >
                <!-- <li class="home-bread">首页</li> -->
                <li>新闻详情</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End breadcumb Area -->
    <!--Blog Area Start-->
    <div class="blog-details bg-color-2 page-padding">
      <div class="container">
        <div class="row">
          <div class="blog-details">
            <!-- Start single blog -->
            <div class="col-md-12 col-sm-12 col-xs-12">
              <!-- single-blog start -->
              <article class="blog-post-wrapper">
                <div class="blog-banner">
                  <!-- <a  class="blog-images">
										<img src="../assets/new/img/blog/b2.jpg" alt="">
									</a> -->
                  <div class="blog-content">
                    <div class="blog-meta">
                      <span class="date-type">
                        时间：{{
                          shijian.split("T").join(" ").split("+").shift()
                        }}
                      </span>
                    </div>
                    <h4>{{ biaoti }}</h4>
                    <p v-html="neirong">。</p>
                    <!-- <blockquote>
											<p>Consultations are slowly gaining immense recognition and are growing phenomenally with more and more people trading with this digital currency. The universal acceptance of Consultation.</p>
										</blockquote>							 -->
                    <!-- <p>文章转自：{{laiyuan}}</p> -->
                  </div>
                </div>
              </article>
              <div class="clear"></div>
              <!-- single-blog end -->
            </div>
          </div>
          <!-- End main column -->
          <!-- Start single blog -->

          <!-- End single blog -->
        </div>
        <!-- End row -->
      </div>
    </div>
  </main>
</template>
<script>
import { setInterval } from 'timers'
export default {
  metaInfo: {
    title:
      '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:
          '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:
          '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      id: -1,
      biaoti: '',
      zhaiyao: '',
      zuozhe: '',
      laiyuan: '',
      neirong: '',
      shijian: '',
      time: ''
    }
  },
  methods: {
    chakanid () {
      this.id = this.$route.query.id
      this.http.chawzid(this.id).then(res => {
        if (res.status == 200 && res.data.code === 200) {
          this.biaoti = res.data.data.article.article_title
          this.zhaiyao = res.data.data.article.article_summary
          this.zuozhe = res.data.data.article.article_author
          this.laiyuan = res.data.data.article.article_source
          this.neirong = res.data.data.article.article_content
          this.shijian = res.data.data.article.created_at
        }
      })
    }
  },
  mounted () {
    this.chakanid()
    sessionStorage.setItem('detail', true)
  },
  beforeUpdate () {},
  updated () {},
  destroyed () {
    // clearInterval(this.time);
  }
}
</script>
<style scoped>
.Article {
  padding: 6.25rem;
  width: 43.75rem;
  height: 100%;
  background: #fff;
  margin: 0 auto;
  color: #666;
}
.content {
  margin-top: 3.125rem;
}
.Article h2 {
  font-size: 2.1875rem;
  line-height: 3.75rem;
  text-align: center;
  font-weight: bold;
  margin-bottom: 3.125rem;
}
.Article span {
  display: block;
  font-size: 0.875rem;
  color: #c7c7c7;
  line-height: 1.875rem;
}
.Article p {
  line-height: 2.5rem;
  font-size: 1.25rem;
  color: #666;
  text-indent: 2.5rem;
}
.Article >>> img {
  display: block;
  width: 100%;
  height: auto;
  margin: 1.25rem 0;
}
.Article a {
  font-weight: bold;
  text-decoration: underline;
}
.Article .http {
  margin-top: 1.875rem;
}
.MsoNormal {
  min-height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Article_details.vue